import Confirm from './Confirm.vue';

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/emailconfirm/index.ts